module.exports = __webpack_public_path__ + "img/pic_xishouye2.c37fe24a.png";